import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  panel: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  headline: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap'
  },
  meta: {
    marginTop: theme.spacing(0.5)
  },
  // The raw payload is evidence to paste into a ticket, so it must survive
  // copying: monospace, wrapped rather than truncated, and scrollable rather
  // than pushing the page wide.
  payload: {
    fontFamily: 'monospace',
    fontSize: 12,
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    maxHeight: 260,
    overflowY: 'auto',
    backgroundColor: theme.palette.action.hover,
    padding: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    direction: 'ltr' as const,
    textAlign: 'left' as const
  },
  payloads: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  }
}))

export default useStyles
